import React, { useState } from 'react';
interface FAQ {
  question: string;
  // answer: string;
  // answer: string | JSX.Element;
  answer: React.ReactNode;
  icon: string;
}
interface FAQSectionProps {
  faqsData: FAQ[];
}
const FAQSection: React.FC<FAQSectionProps> = ({ faqsData }) => {
  const [activeIndexes, setActiveIndexes] = useState<number[]>([]);

  const handleToggle = (index: number) => {
    setActiveIndexes((prevIndexes) =>
      prevIndexes.includes(index)
        ? prevIndexes.filter((i) => i !== index) // Remove if already open
        : [...prevIndexes, index] // Add if not open
    );
  };

  return (
    <div className="wp-block-k12-faqs">
      <div style={{ height: '20px' }} aria-hidden="true" className="wp-block-spacer" />
      <div className="accordion" id="GnimFzYj">
        {faqsData.map((faq, index) => (
          <div key={index} className="wp-block-k12-faq-card">
            <div className="accordion-item">
              <div className="d-flex align-items-center gap-1 mb-1 ms-4">
                <img decoding="async" src={faq.icon} alt="Question" className="icon-faq" />
                <h4 className="accordion-header" id={`panelsStayOpen-heading-${index}`}>
                  <button
                    className={`accordion-button ${activeIndexes.includes(index) ? '' : 'collapsed'}`}
                    type="button"
                    aria-expanded={activeIndexes.includes(index) ? 'true' : 'false'}
                    aria-controls={`panelsStayOpen-collapse-${index}`}
                    onClick={() => handleToggle(index)}
                  >
                    <h4>{faq.question}&nbsp;</h4>
                  </button>
                </h4>
              </div>
              <div
                id={`panelsStayOpen-collapse-${index}`}
                className={`accordion-collapse collapse ${activeIndexes.includes(index) ? 'show' : ''}`}
                aria-labelledby={`panelsStayOpen-heading-${index}`}
              >
                <div className="accordion-body">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;